import { Component, computed, ElementRef, HostListener, input, output, signal, viewChild } from '@angular/core';
import { Wk8ButtonComponent } from '@features/wk8/core/wk8-button/wk8-button.component';
import { Wk8ProgressLightsComponent } from '@features/wk8/core/wk8-progress-lights/wk8-progress-lights.component';

@Component({
  selector: 'wk8-screen',
  imports: [Wk8ButtonComponent, Wk8ProgressLightsComponent],
  templateUrl: './wk8-screen.component.html',
  styleUrl: './wk8-screen.component.css',
})
export class Wk8ScreenComponent {
  // INPUT
  numSteps = input(0);
  numCompleted = input(0);
  swapButton = input.required<'disabled' | 'hidden' | 'default'>();
  swapButtonIcon = input<'reset' | 'up-down-arrows'>('up-down-arrows');
  submitButton = input.required<'disabled' | 'hidden' | 'default'>();

  // OUTPUT
  submitted = output();
  swapped = output();

  // INTERNAL
  // We (re)compute the border pixel sizes based on desired percenstage, since borders don't support percentage-based sizes
  readonly borderLeftPercentage = 0.5;
  readonly borderTopPercentage = 2;

  screenElement = viewChild<ElementRef<HTMLDivElement>>('screen');
  windowSize = signal({ width: window.innerWidth, height: window.innerHeight });

  @HostListener('window:resize')
  onResize() {
    this.windowSize.set({ width: window.innerWidth, height: window.innerHeight });
  }

  borderLeftPixels = computed(() => {
    this.windowSize(); // trigger recomputation on resize
    const el = this.screenElement();
    return el ? Math.floor((el.nativeElement.offsetWidth * this.borderLeftPercentage) / 100) : 0;
  });

  borderTopPixels = computed(() => {
    this.windowSize(); // trigger recomputation on resize
    const el = this.screenElement();
    return el ? Math.floor((el.nativeElement.offsetHeight * this.borderTopPercentage) / 100) : 0;
  });
}
